import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useOpenSupportCase from 'utils/hooks/useOpenSupportCase';

export const OpenSupportCaseRedirect = () => {
  const { url } = useOpenSupportCase();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (url) {
      window.open(url, '_blank');

      if (location.key === 'default') {
        navigate('/')
      } else {
        navigate(-1);
      }
    }
  }, [url]);

  return null;
};
